import _arrayLikeToArray from './arrayLikeToArray.js';

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

export { _arrayWithoutHoles as default };
